module.exports = __webpack_public_path__ + "static/img/cloud_saaS_acceleration_img_2.abf42df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_saaS_acceleration_img_2.jpg
// module id = 7/Us
// module chunks = 0